export default {
	photos: []
}